import { z } from 'zod';
import { dataGridSearchFields } from '@/features/dynamic-table';
import { ALERT_CATEGORY_KEYS } from '@/routes/_staff/equipment/_layout/alerts/-constants';
export const ItemAlertsSearchSchema = z.object({
  ...dataGridSearchFields,
  category: z.enum(ALERT_CATEGORY_KEYS).default('REPLACEMENT_DUE'),
  freeText: z.string().optional()
});